import type { TrackerAction } from "../../use-cases/simple-create/hooks/UseTrackingTextInput";

interface FieldProps<TValue, TOnChange> {
  disabled?: boolean;
  editedValue: TValue;
  onChange: TOnChange;
  trackerAction: TrackerAction;
}

interface ComponentProps {
  disabled?: boolean;
}

interface CombinedProps<TValue, TOnChange> {
  disabled?: boolean;
  onValueChange: TOnChange;
  trackerAction: TrackerAction;
  value: TValue;
}

export function getFieldProps<TValue, TOnChange>(
  props: ComponentProps,
  fieldProps: FieldProps<TValue, TOnChange>,
): CombinedProps<TValue, TOnChange> {
  return {
    value: fieldProps.editedValue,
    onValueChange: fieldProps.onChange,
    disabled: props.disabled || fieldProps.disabled,
    trackerAction: fieldProps.trackerAction,
  };
}
